export const data = [
    {
        title: "Home",
        link: "/",
    },
    {
        title: "Services",
        link: "/services",
    },
    {
        title: "Register Your Business",
        link: "business/register",
    },
];
